export function getPaymentInfo(data: any) {
  const empty = {
    subtotal: 0,
    tax_total: 0,
    quantity: 0,
    total: 0,
    original_subtotal: 0,
    discounted: 0,
  };

  // nếu truyền trực tiếp array
  let shops = Array.isArray(data)
    ? data
    : data?.cart_shops || [];

  if (!Array.isArray(shops) || shops.length === 0) {
    return empty;
  }

  return shops.reduce((acc, shop) => {
    const subtotal = parseFloat(shop?.subtotal || 0);
    const tax = parseFloat(shop?.tax_total || 0);
    const total =
      shop?.total !== undefined
        ? parseFloat(shop.total)
        : subtotal + tax;

    acc.subtotal += subtotal;
    acc.tax_total += tax;
    acc.quantity += Number(shop?.quantity || 0);
    acc.total += total;
    acc.original_subtotal += parseFloat(shop?.original_subtotal || 0);
    acc.discounted += parseFloat(shop?.discounted || 0);

    return acc;
  }, empty);
}